export default __webpack_public_path__ + "static/media/pak6.14e2b591.jpg";